import { ScreenDevicePage } from '@hq/screen-scan';
import { useNavigate } from 'react-router-dom';
import { hq } from '../session';

/**
 * 我的大屏（SUPPLIER 门户）：本主体已授权的大屏，可逐台吊销。
 * 确认动作不在后台做——必须到屏前看屏上的 12 位申请码，再到「申请码确认」页填入。
 */
export default function ScreenDevices() {
  const navigate = useNavigate();

  return (
    <ScreenDevicePage
      hq={hq}
      title="我的大屏"
      canDisable
      onScan={() => navigate('/screen-scan')}
      onOpenScreen={() => window.open('/screen', '_blank')}
      hint="本供应商主体已授权的大屏。新增大屏请点右上角「申请码确认」，把大屏上显示的 12 位申请码按 4-4-4 三段填入即可；停用的大屏可在此吊销，吊销后需重新申请授权。"
    />
  );
}
